import React, { createContext, useContext, useCallback, useRef, useState } from 'react';

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const countRef = useRef(0);
  const [, forceUpdate] = useState(0);

  const registerModal = useCallback((open) => {
    if (open) {
      countRef.current += 1;
    } else {
      countRef.current = Math.max(0, countRef.current - 1);
    }
    forceUpdate((n) => n + 1);
  }, []);

  const isAnyModalOpen = countRef.current > 0;

  return (
    <ModalContext.Provider value={{ isAnyModalOpen, registerModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) return { isAnyModalOpen: false, registerModal: () => {} };
  return ctx;
}

/** Modal açık/kapalı durumunu context'e bildirir. Modal kullanan sayfalarda open prop'u ile kullanın. */
export function ModalReporter({ open, children }) {
  const { registerModal } = useModal();

  React.useEffect(() => {
    if (open) registerModal(true);
    return () => registerModal(false);
  }, [open, registerModal]);

  return children || null;
}
